import React, { useEffect, useState } from 'react';
import ImageGallery from 'react-image-gallery';



const CrousalSlider = (props) => {
    var data = [];
    if (props.feedFor == "video_testimonial") {
        return (
            <div className='mt-2'>
                <ImageGallery items={props.images} />
            </div>
        )
    }
    else {
        props.images.map((item) => {
            data.push({
                original: item.imageurl,
                thumbnail: item.imageurl,

            })
        })
        return (
            <div className='mt-2'>
                <ImageGallery items={data} />
            </div>
        )
    }

}


export default CrousalSlider;